import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import blogData from "../../data/blogData";


export default function Blog() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = ["All", ...new Set(blogData.map((b) => b.category))];

  const filteredBlogs = blogData.filter((blog) => {
    const matchesSearch = blog.title.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === "All" || blog.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const recentPosts = blogData.slice(0, 5);
  const allTags = [...new Set(blogData.flatMap((b) => b.tags))];

  return (
    <>
      {/* ========== BREADCRUMBS ========== */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li>Blog</li>
          </ol>
          <h2>Our Blog</h2>
        </div>
      </section>

      {/* ========== BLOG SECTION ========== */}
      <section id="blog" className="blog">
        <div className="container">
          <div className="row">

            {/* ========== LEFT: Blog Entries ========== */}
            <div className="col-lg-8 entries">
              {filteredBlogs.length === 0 ? (
                <div className="text-center py-5">
                  <h4>No blog posts found</h4>
                  <p style={{ color: "#888" }}>Try a different search term or category.</p>
                </div>
              ) : (
                filteredBlogs.map((blog) => (
                  <article className="entry" key={blog.id}>
                    <div className="entry-img">
                      <img src={blog.image} alt={blog.title} className="img-fluid" />
                    </div>
                    <h2 className="entry-title">
                      <Link to={`/blog/${blog.id}`}>{blog.title}</Link>
                    </h2>
                    <div className="entry-meta">
                      <ul>
                        <li className="d-flex align-items-center">
                          <i className="bi bi-person" />{" "}
                          <span>{blog.author}</span>
                        </li>
                        <li className="d-flex align-items-center">
                          <i className="bi bi-clock" />{" "}
                          <time>{blog.date}</time>
                        </li>
                        <li className="d-flex align-items-center">
                          <i className="bi bi-chat-dots" />{" "}
                          <span>{blog.comments} Comments</span>
                        </li>
                      </ul>
                    </div>
                    <div className="entry-content">
                      <p>{blog.excerpt}</p>
                      <div className="read-more">
                        <Link to={`/blog/${blog.id}`}>Read More</Link>
                      </div>
                    </div>
                  </article>
                ))
              )}
            </div>

            {/* ========== RIGHT: Sidebar ========== */}
            <div className="col-lg-4">
              <div className="sidebar">

                {/* Search */}
                <h3 className="sidebar-title">Search</h3>
                <div className="sidebar-item search-form">
                  <input
                    type="text"
                    placeholder="Search blogs..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ width: "100%", padding: "10px", borderRadius: "5px", border: "1px solid #ddd" }}
                  />
                </div>

                {/* Categories */}
                <h3 className="sidebar-title">Categories</h3>
                <div className="sidebar-item categories">
                  <ul>
                    {categories.map((cat, index) => (
                      <li key={index}>
                        <span
                          onClick={() => setSelectedCategory(cat)}
                          style={{
                            cursor: "pointer",
                            color: selectedCategory === cat ? "#007bff" : "#333",
                            fontWeight: selectedCategory === cat ? "700" : "400",
                          }}
                        >
                          {cat}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>

                {/* Recent Posts */}
                <h3 className="sidebar-title">Recent Posts</h3>
                <div className="sidebar-item recent-posts">
                  {recentPosts.map((post) => (
                    <div className="post-item clearfix" key={post.id}>
                      <img src={post.image} alt={post.title} />
                      <h4>
                        <Link to={`/blog/${post.id}`}>{post.title}</Link>
                      </h4>
                      <time>{post.date}</time>
                    </div>
                  ))}
                </div>

                {/* Tags */}
                <h3 className="sidebar-title">Tags</h3>
                <div className="sidebar-item tags">
                  <ul>
                    {allTags.map((tag, index) => (
                      <li key={index}>
                        <span style={{ cursor: "pointer" }}>{tag}</span>
                      </li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}